/**
 * Created by lenovo on 2017/3/13.
 */
import React,{Component} from 'react'
import {Link} from 'react-router'
import {language} from 'UTIL/common'

export default class BoxHeader extends Component{
    render(){
        return (
                <div className="box-header with-border">
                    <i className="fa fa-list"></i>
                    <h3 className="box-title">{language()[this.props.title]}</h3>
                    {this.props.name == undefined?"":<div style={{marginRight:"10px",float:"right"}} >
                            <Link to={this.props.url} className="btn btn-success btn-md" >
                            <i className="fa fa-plus-circle"></i>
                                {language()[this.props.name]}
                                
                            </Link>
                        </div>}
                </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/component/boxHeader.js